import { Dialog } from './Dialog/Dialog';
import Button from '../../button/buttonUI';
import Icon from '../../icon/icon';
import { Dictionary } from '@ts/dictionary';

export default function MobileMenuHeader({
  menuDictionary,
  show,
  onClick,
}: {
  show: boolean;
  onClick: () => void;
  menuDictionary: Dictionary;
}) {
  if (show) {
    return (
      <Dialog.Title>
        <Button className="flex items-center gap-1" onClick={onClick}>
          <Icon name="leftArrow" color="black" size={12} />
          {menuDictionary.back}
        </Button>
      </Dialog.Title>
    );
  }

  return <Dialog.Title>{menuDictionary.menu}</Dialog.Title>;
}
